module.exports = __webpack_public_path__ + "img/farmaconNuevoOriginal.c1568daa.png";